<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table
      ref="zTable"
      :data="tableData"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="transDate"
        label="日期"
      />
      <af-table-column
        fixed
        prop="varietyName"
        label="品种名称"
      />
      <af-table-column
        fixed
        prop="businessAmount"
        label="交易量"
      />
      <af-table-column
        prop="intraDayAmount"
        label="当开当平量"
      />
      <af-table-column
        prop="overnightAmount"
        label="非当开当平量"
      />
      <af-table-column
        prop="fee"
        label="软件使用费"
      />
      <af-table-column
        prop="intraDayDiscountFee"
        label="日返"
      />
      <af-table-column
        prop="overnightDiscountFee"
        label="月返"
      />
      <af-table-column
        prop="totalMReturnScaleAmount"
        label="比例返"
      />
      <af-table-column
        prop="free"
        label="信息服务费"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentNo"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'

function Query () {
  this.marketId = '000' // 组织编号
  this.date = []
}
export default {
  name: 'TransactionCostInquiry',
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      marketId: '',
      activeName: 'transactionCostInquiry', // tab生效

      param: {},
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        isTradeDay: 1, // 历史
      }
      this.query.date = this.query.date ? this.query.date : []
      param.startTime = this.query.date.length ? this.$dayjs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endTime = this.query.date.length ? this.$dayjs(this.query.date[1]).format('YYYYMMDD') : ''
      this.param = param
      let res = await api.spotPurchaseSaleInquiry.TransactionCostInquiry(param)
      this.total = res.data.totalElements
      this.tableData = res.data.rows
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    open (row) {
      this.row = row
      this.isShow = true
    },
    // 关闭弹窗
    shutDown () {
      this.isShow = false
    },
    // 导出
    toDownload () {
      let param = {
        ...this.param,
        tableUser: this.$store.state.user.name,
        tableName: '历史交易费用',
        excelParentPath: 'fund',
        excelPath: 'tradeReport',
        marketId: this.marketId,
        currentNo: 1,
        pageSize: 2000,
        exportKeyMap: [{
          fieldLabel: '日期',
          excelColumn: 'transDate'
        },
        {
          fieldLabel: '品种名称',
          excelColumn: 'varietyName'
        },
        {
          fieldLabel: '交易量',
          excelColumn: 'businessAmount'
        },
        {
          fieldLabel: '当开当平量',
          excelColumn: 'intraDayAmount'
        },
        {
          fieldLabel: '非当开当平量',
          excelColumn: 'overnightAmount'
        },
        {
          fieldLabel: '软件使用费',
          excelColumn: 'fee'
        },
        {
          fieldLabel: '日返',
          excelColumn: 'intraDayDiscountFee'
        },
        {
          fieldLabel: '月返',
          excelColumn: 'overnightDiscountFee'
        },
        {
          fieldLabel: '比例返',
          excelColumn: 'totalMReturnScaleAmount'
        },
        {
          fieldLabel: '信息服务费',
          excelColumn: 'free'
        },
        ]
      }
      this.$utils.getExcelFile(this, api.exportExcelData, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
